<template>
  <div class="prize-box">
    <h2>{{ dialogData.title }}</h2>
    <el-carouse
      :interval="5000"
      arrow="always"
      indicator-position="none"
      :autoplay="false"
      :loop="false"
    >
      <el-carousel-item v-for="item in dialogData.prize" :key="item.id">
        <div class="prize-content">
          <div class="prize-item">
            <div>
              <img :src="item.image_url" alt="" />
              <p>{{ item.name }}</p>
            </div>
          </div>

          <button
            @click="handleCode(item)"
            class="btn"
            v-if="['1', '2', '5', '6'].indexOf(item.award_type) > -1"
          >
            提取兑换码
          </button>
          <button
            @click="handleAddRess(item)"
            class="btn"
            v-else-if="item.award_type == 3"
          >
            填写寄送地址
          </button>
        </div>
      </el-carousel-item>
    </el-carouse>
    <button @click="handleCancel" class="x"></button>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { DIALOG_OPTION } from '../../store/mutation-types'
import { Carousel, CarouselItem } from 'element-ui'
export default {
  props: {
    dialogData: {
      type: Object,
      default: function() {
        return {}
      },
    },
  },
  components: {
    elCarouse: Carousel,
    elCarouselItem: CarouselItem,
  },
  methods: {
    ...mapMutations([DIALOG_OPTION]),
    handleCancel() {
      this.$store.commit(DIALOG_OPTION, {
        dialogTableVisible: false,
      })
    },
    handleAddRess(item) {
      //填写寄送地址
      this.handleCancel()
      setTimeout(() => {
        this.$store.commit(DIALOG_OPTION, {
          type: 'EVENTS_ADDRESS',
          dialogTableVisible: true,
          data: {
            prize: item,
          },
        })
      }, 430)
    },
    handleCode(item) {
      this.handleCancel()
      setTimeout(() => {
        this.$store.commit(DIALOG_OPTION, {
          type: 'PRIZE_CODE',
          dialogTableVisible: true,
          data: {
            type: item.award_type == 1 ? 'CODE2' : 'CODE1',
            code: item.code.split(','),
          },
        })
      }, 430)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/base.scss';
.prize-box {
  width: 606px;
  height: 552px;
  background-image: url('https://img.dota2.com.cn/file/f8/db/f8dbc8352ca4263dfecb1b00795e3a3e1596597636.png');
  text-align: center;
  padding: 106px 10px 0;
  margin: 0 auto;
  position: relative;
  h2 {
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 4px;
    margin-bottom: 20px;
    color: #c3f1f6;
  }
  .prize-content {
    height: 100%;
  }
  .prize-item {
    height: 242px;
    font-size: 18px;
    color: #a5a7bf;
    position: relative;
    top: -10px;
    > div {
      position: absolute;
      top: 50%;
      width: 100%;
      transform: translateY(-50%);
      p {
        font-size: 14px;
        color: #52c2d6;
        margin-top: 10px;
      }
    }
    img {
      display: inline-block;
      vertical-align: middle;
      max-height: 200px;
    }
  }
  .btn {
    width: 193px;
    height: 56px;
    background-color: #fa9a28;
    color: #fff;
    margin: 0px auto;
    font-size: 16px;
    cursor: pointer;
    border-radius: 6px;
  }
  .x {
    position: absolute;
    right: 0px;
    top: 62px;
    width: 40px;
    height: 40px;
    cursor: pointer;
    background-image: url('../../assets/close.png');
  }
}
/deep/ .el-carousel__container {
  height: 337px;
}
/deep/ .el-carousel__arrow {
  width: 37px;
  height: 60px;
  // background-image: url('../../assets/dialog/icon-prev.png');
  background-size: 100% 100%;
  top: 29%;
  transition: 0s;
  &.el-carousel__arrow--right {
    // background-image: url('../../assets/dialog/icon-next.png');
  }
  i {
    display: none;
  }
}
</style>
